import { useState } from "react";
import { Button } from "@design-system/Button/Button";
import { DetailsAside } from "@design-system/DetailsAside/DetailsAside";
import { BooleanControl, PlaygroundSelect } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./OverlayPlayground.module.scss";

const reviewStates = ["Needs review", "Reviewed", "Blocked"] as const;
type ReviewState = (typeof reviewStates)[number];

export const DetailsAsidePlayground = () => {
    const [reviewState, setReviewState] = useState<ReviewState>("Needs review");
    const [hasActivity, setHasActivity] = useState(true);
    const [hasFooter, setHasFooter] = useState(true);

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Sample state</h2>
                        <PlaygroundSelect<ReviewState>
                            options={reviewStates}
                            value={reviewState}
                            onChange={setReviewState}
                        />
                    </section>
                    <section>
                        <h2>Content</h2>
                        <div className={styles.controls}>
                            <BooleanControl
                                label="Activity section"
                                checked={hasActivity}
                                onChange={setHasActivity}
                            />
                            <BooleanControl
                                label="Footer action"
                                checked={hasFooter}
                                onChange={setHasFooter}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary="394px detail panel"
                alignment="start"
                output={JSON.stringify(
                    { reviewState, hasActivity, hasFooter },
                    null,
                    2,
                )}
            >
                <div className={styles.detailsFrame}>
                    <DetailsAside
                        recomputeTopOffsetOn={[reviewState, hasActivity]}
                    >
                        <div className={styles.detailsContent}>
                            <h2>Stripe subscription</h2>
                            <p>Software expense · Aug 12, 2026</p>
                            <div className={styles.detailRow}>
                                <span>Amount</span>
                                <strong>−$79.00</strong>
                            </div>
                            <div className={styles.detailRow}>
                                <span>Status</span>
                                <strong>{reviewState}</strong>
                            </div>
                            <div className={styles.detailRow}>
                                <span>Category</span>
                                <strong>Software</strong>
                            </div>
                            {hasActivity && (
                                <section>
                                    <h3>Activity</h3>
                                    <p>
                                        Categorized automatically from a
                                        matching transaction.
                                    </p>
                                </section>
                            )}
                            {hasFooter && (
                                <Button variant="primary" size="md">
                                    Mark as reviewed
                                </Button>
                            )}
                        </div>
                    </DetailsAside>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
